import { print } from 'graphql';
import getPriceAndStock from './variants.graphql';

export default { getPriceAndStock: print(getPriceAndStock) };
